export type PostNavigateCallbackType = (args?: unknown) => unknown;
